import { Gray_Light_100, Gray_Light_200, Pink_Light_050, Pink_Light_400 } from '@common/styles';
import styled from '@emotion/styled';

interface Props {
  checked?: boolean;
  disabled?: boolean;
}

export const Root = styled.div<Props>`
  transition: background-color 300ms;
  position: relative;
  width: 34px;
  height: 14px;
  background-color: ${({ checked }) => (checked ? Pink_Light_400 : Gray_Light_200)};
  border-radius: 15px;
  display: flex;
  align-items: center;
  padding: 2px;
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};

  &::before {
    transition: transform 300ms;
    content: '';
    width: 20px;
    height: 20px;
    background-color: ${({ checked }) => (checked ? Pink_Light_050 : Gray_Light_100)};
    border-radius: 100%;
    transform: translateX(${({ checked }) => (checked ? '80%' : '-2px')});
  }
`;

export const Checkbox = styled.input`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
`;
